import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-slate-200/70 bg-white/70 py-6 text-sm text-slate-500 backdrop-blur-md dark:border-slate-800 dark:bg-slate-950/70 dark:text-slate-400">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-2.5 px-4 text-xs sm:flex-row sm:gap-3 sm:px-6 sm:text-sm lg:px-8">
        <p className="text-center sm:text-left">
          © {new Date().getFullYear()} <span className="font-medium">Marco Biosa</span>. All
          rights reserved.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 text-[10px] font-medium uppercase tracking-wide sm:gap-4 sm:text-xs">
          <button
            onClick={() => {
              const el = document.getElementById('home');
              el?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="transition hover:text-slate-700 dark:hover:text-slate-200"
          >
            Back to top
          </button>
          <Link
            to="/"
            className="transition hover:text-slate-700 dark:hover:text-slate-200"
          >
            Home
          </Link>
          <Link
            to="/projects"
            className="transition hover:text-slate-700 dark:hover:text-slate-200"
          >
            Projects
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



